import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EshavaDialogAnimationRef, eshavaDialogInOutAnimation } from '../../models';

@Component({
    selector: 'lib-eshava-dual-dialog',
    animations: [eshavaDialogInOutAnimation],
    templateUrl: './eshava-dual-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './eshava-dual-dialog.component.scss'
})
export class EshavaDualDialogComponent implements AfterViewInit {

  public bodyTopShadow = false;
  public bodyBottomShadow = false;

  public scrollSpyTopShadow = false;
  public scrollSpyBottomShadow = false;

  public animateSidepanel = false;

  @Input()
  public title = '';

  @Input()
  public sidepanelTitle = '';

  @Input()
  public hasScrollSpy = false;

  @Input()
  public sidePanelWidth = 704;

  @Input()
  public hideSidePanel = false;

  @Input()
  public dialogHeight: 'static' | 'dynamic' = 'static'

  @Input()
  public dialogWidth: 'default' | 'small' = 'default'

  @ViewChild('modalBody') body!: ElementRef;
  @ViewChild('modalScrollSpy') scrollSpy!: ElementRef;

  constructor(private _cdr: ChangeDetectorRef, @Inject(EshavaDialogAnimationRef) public animationRef: EshavaDialogAnimationRef) { }

  public ngAfterViewInit(): void {
    this.calcShadowsOnBody(this.body.nativeElement);
    if (this.hasScrollSpy) {
      this.calcShadowsOnScrollSpy(this.scrollSpy.nativeElement);
    }
    this._cdr.detectChanges();

    setTimeout(() => this.animateSidepanel = true, 100);
  }


  public onBodyScroll(event: any): void {
    this.calcShadowsOnBody(event.target);
  }

  public onScrollSpyScroll(event: any): void {
    this.calcShadowsOnScrollSpy(event.target);
  }

  private calcShadowsOnBody(event: any): void {
    this.bodyTopShadow = event.scrollTop > 0;
    this.bodyBottomShadow = event.scrollTop + event.clientHeight < event.scrollHeight;
  }

  private calcShadowsOnScrollSpy(event: any): void {
    this.scrollSpyTopShadow = event.scrollTop > 0;
    this.scrollSpyBottomShadow = event.scrollTop + event.clientHeight < event.scrollHeight;
  }
}
